module.exports = __webpack_public_path__ + "static/media/innowind-roughness-bannerimg.0dd01b31.jpg";